module.exports = __webpack_public_path__ + "assets/img/happy.5440c995.jpg";